export default "__VITE_ASSET__Cah5XsBY__"